import Vue from 'vue';
import VueCookies from 'vue-cookies'
import singleSpaVue from 'single-spa-vue';

import App from './App.vue';
import router from "./router";
import i18n from './i18n'

import '@moex/ui-framework/dist/themes/default.css';
import UI from '@moex/ui-framework';
Vue.use(UI)

Vue.use(VueCookies)

Vue.config.productionTip = false

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render(h) {
      return h(App, {
        props: {
          rest: this.rest,
          config: this.configuration,
          menu: this.menu,
          auth: this.auth,
          locale: this.locale,
          orgManager: this.orgManager,
          retrieveInfo: this.retrieveInfo,
        },
      });
    },
    i18n,
    router,
  },
});

export const bootstrap = vueLifecycles.bootstrap;
export const mount = vueLifecycles.mount;
export const unmount = vueLifecycles.unmount;
